import React from 'react'

class ChunkErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    // Only intercept chunk load failures; let other errors propagate normally
    if (error && error.name === 'ChunkLoadError') {
      return { hasError: true }
    }
    return null
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            minHeight: 200,
            gap: 12,
          }}
        >
          <p style={{ margin: 0 }}>
            This page failed to load, likely due to a recent update.
          </p>
          <button onClick={this.handleReload}>Reload page</button>
        </div>
      )
    }
    return this.props.children
  }
}

export default ChunkErrorBoundary
